<template>
    <div class="slider-page">
        <div class="scroll-wrapper" @wheel="onWheel" @touchstart="onTouchStart" @touchmove="onTouchMove">
            <div class="scroll-inner" ref="scrollInner">
                <slot></slot>
            </div>
        </div>

        <div class="slide-indicator" v-if="percentageSize < 100">
            <div class="bounds"></div>
            <div class="inner" :style="{ width: percentageSize + '%' }"></div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .slider-page{
        // overflow-x:hidden;
        // overflow-y:auto;
        overflow: hidden;
        height:100%;
        width: 100vw;
    }

    .scroll-wrapper{
        width:100%;
        height:100%;
        line-height:0;
    }

    .scroll-inner{
        display:inline-block;
        max-width:10000%;
        min-width:100%;
        height:100%;

        & > *{
            line-height:1;
        }
    }

    .slide-indicator{
        position:absolute;
        bottom:1rem;
        left:50%;
        transform:translateX(-50%);

        width:100px;
        height:2rem;

        border:0.1rem solid #A5147E;
        border-radius:0.5rem;

        padding:0.1rem;

        .bounds{
            position:absolute;
            top:3px;
            left:3px;
            right:3px;
            bottom:3px;
        }

        .inner{
            border:2px solid #A5147E;
            height:99%;
            width:1rem;

            display:inline-block;
            border-radius:0.25rem;

            width:50%;
            background-color:rgba( #A5147E, 0.5 );

            transition: margin-left 0.2s ease-out;
        }
    }
</style>

<script>
    import { gsap, Draggable } from '@/vendor';

    export default {
        name: 'SliderPage',
        meta: {
            title: 'Sliderpage',
            color: '#a5147e',
            sub: true
        },
        data()
        {
            return {
                offset: 0,
                percentageOffset: 0,
                percentageSize: 0
            };
        },

        watch: {
            percentageOffset: function( pVal )
            {
                // console.log( 'pVal', pVal );
                // console.log( 'currentX', this.draggableScrub[0].x );

                // this.draggableScrub[0].x = -pVal * this.draggableScrub[0].maxX;
                // console.log( 'newX', this.draggableScrub[0].x );
                gsap.set( '.inner', { x: ( -pVal * this.draggableScrub[0].maxX ) / 100 * ( 100 - this.percentageSize ) });
                this.draggableScrub[0].update();
            }
        },

        mounted()
        {
            this.scrollInnerWidth = this.$refs.scrollInner.getBoundingClientRect().width;

            this.touchStartPos = null;

            this.onResizeRef = this.onResize;
            window.addEventListener( 'resize', this.onResizeRef );
            this.onResize();
            this.calculateOffset();

            this.draggableScrub = Draggable.create( '.slide-indicator .inner', {
                type: 'x',
                bounds: '.bounds',

                onDrag: () =>
                {
                    // console.log( this.draggableScrub );
                    this.offset = ( this.draggableScrub[0].x / this.draggableScrub[0].maxX ) * -this.scrollInnerWidth;
                    this.calculateOffset();
                }
            });
        },

        beforeDestroy()
        {
            window.removeEventListener( 'resize', this.onResizeRef );
        },

        methods: {
            animateIn()
            {
            },
            onWheel( e )
            {
                if( this.scrollInnerWidth <= window.innerWidth )
                {
                    // deze nooit meer weg halen
                    this.scrollInnerWidth = this.$refs.scrollInner.getBoundingClientRect().width;
                }

                let direction = e.wheelDeltaY || ( -e.deltaY * 25 ); // > 0 is up, < 0 is down

                if( Math.abs( this.offset ) > 0 && direction > 0 )
                {
                    e.stopPropagation();
                }
                if( Math.abs( this.offset ) < this.scrollInnerWidth - window.innerWidth && direction < 0 )
                {
                    e.stopPropagation();
                }

                if( gsap.isTweening( this.$refs.scrollInner ) )
                {
                    e.stopPropagation();
                }

                // set the new offset
                this.offset += e.wheelDeltaY || ( -e.deltaY * 25 );

                // console.log( this.offset );

                this.calculateOffset();
            },

            onTouchStart( e )
            {
                this.scrollInnerWidth = this.$refs.scrollInner.getBoundingClientRect().width;
                this.touchStartPos = e.changedTouches[0].screenX;
            },

            onTouchMove( e )
            {
                this.offset += -( this.touchStartPos - e.changedTouches[0].screenX ); // divide to slow it down

                this.touchStartPos = e.changedTouches[0].screenX;
                this.calculateOffset();
            },

            onResize()
            {
                // save the % offset of the old width
                this.percentageOffset = this.offset / this.scrollInnerWidth;
                // get the new width, if there are responsive elements that change the size
                this.scrollInnerWidth = this.$refs.scrollInner.getBoundingClientRect().width;

                // apply the old offset on the next width
                this.offset = this.scrollInnerWidth * this.percentageOffset;

                this.percentageSize = window.innerWidth / this.scrollInnerWidth * 100;

                this.calculateOffset();
            },

            calculateOffset()
            {
                // if no scroll needed, set offset to 0
                if( window.innerWidth > this.scrollInnerWidth )
                {
                    this.percentageOffset = 0;
                    this.offset = 0;
                    gsap.set( this.$refs.scrollInner, { x: 0 });
                    return;
                }

                // constrain the max offsets
                this.offset = Math.min( 0, this.offset );
                this.offset = Math.max( -this.scrollInnerWidth + window.innerWidth, this.offset );

                this.percentageOffset = this.offset / ( this.scrollInnerWidth - window.innerWidth );

                if( this.offset === this.oldOffset )
                {
                    return;
                }

                // apply
                gsap.to( this.$refs.scrollInner, { x: this.offset, duration: 0.5 });

                this.oldOffset = this.offset;
            }
        }
    };
</script>
